// eslint-disable-next-line
// @ts-ignore
if (typeof global === 'undefined') {
  // eslint-disable-next-line
  (window as any).global = window;
}
